import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function AffirmLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <AffirmLogo.Outline {...props} />
  ) : (
    <AffirmLogo.Solid {...props} />
  );
}

/**
 * Displays a Solid variant.
 */
AffirmLogo.Outline = function Outline({ name, ...props }: IconProps) {
  return <AffirmLogo.Solid name={name} {...props} />;
};

AffirmLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <rect width="48" height="24" rx="2" fill="#0B0B0B" />
        <g clipPath="url(#clip0_5164_4407)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.77667 11.3252C8.8619 11.3252 7.80143 11.7456 7.22667 12.1815L7.75286 13.2402C8.21429 12.8354 8.95905 12.4929 9.63095 12.4929C10.2705 12.4929 10.6186 12.6953 10.6186 13.1078C10.6186 13.3881 10.3838 13.5282 9.94667 13.5827C8.29524 13.7851 7 14.221 7 15.4432C7 16.4084 7.72048 17 8.83762 17C9.63905 17 10.3514 16.5719 10.6914 16.0114V16.8444H12.181V13.3491C12.181 11.909 11.1367 11.3252 9.77667 11.3252ZM9.2181 15.8791C8.79714 15.8791 8.58667 15.6845 8.58667 15.3575C8.58667 14.7503 9.29095 14.548 10.5781 14.4156C10.5862 15.2252 10.0114 15.8791 9.2181 15.8791Z"
            fill="#FBFAF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.2259 12.3839V11.4809H24.7363V16.8444H26.3311V14.2599C26.3311 13.03 27.1001 12.6719 27.6425 12.6719C27.853 12.6719 28.1363 12.7342 28.3225 12.8665L28.6139 11.4497C28.3711 11.3485 28.112 11.3252 27.9016 11.3252C27.0839 11.3252 26.5659 11.6755 26.2259 12.3839Z"
            fill="#FBFAF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.0137 11.3252C35.1718 11.3252 34.5404 11.8078 34.2085 12.2671C33.9009 11.6677 33.2613 11.3252 32.4842 11.3252C31.6423 11.3252 31.0594 11.7767 30.7842 12.2905V11.4809H29.2461V16.8444H30.8409V14.0809C30.8409 13.0923 31.3832 12.6174 31.8851 12.6174C32.3385 12.6174 32.7594 12.8977 32.7594 13.6294V16.8444H34.3623V14.0809C34.3623 13.0767 34.8885 12.6174 35.4147 12.6174C35.8356 12.6174 36.2809 12.9132 36.2809 13.6216V16.8444H37.8756V13.139C37.8756 11.9324 37.0337 11.3252 36.0137 11.3252Z"
            fill="#FBFAF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.815 11.0837V11.4807H15.3946V10.9357C15.3946 10.2274 15.8155 10.025 16.1798 10.025C16.3903 10.025 16.6655 10.0717 16.8922 10.1962L17.386 9.11419C17.0946 8.95072 16.617 8.80282 15.9774 8.80282C14.9574 8.80282 13.7998 9.35551 13.7998 11.0914V11.4884H12.877V12.6717H13.7998V16.8441H15.3946V12.6639H17.815V16.8441H19.4098V12.6639H20.8589V11.4807H19.4098V10.9357C19.4098 10.2274 19.8308 10.025 20.195 10.025C20.5998 10.025 20.9074 10.1962 20.9074 10.1962L21.4012 9.11419C21.4012 9.11419 20.8993 8.80282 19.9927 8.80282C18.9808 8.79503 17.815 9.34773 17.815 11.0837Z"
            fill="#FBFAF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.8066 11.4805H23.4014V16.8439H21.8066V11.4805Z"
            fill="#FBFAF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.0997 4C26.793 4 22.9559 6.87246 21.8711 10.5701H23.4335C24.3401 7.81437 27.4244 5.4012 31.0997 5.4012C35.5682 5.4012 39.4216 8.67066 39.4216 13.7617C39.4216 14.906 39.2678 15.9335 38.9763 16.8443H40.4901L40.5063 16.7976C40.7573 15.8557 40.8787 14.8359 40.8787 13.7617C40.8787 8.08683 36.5801 4 31.0997 4Z"
            fill="#4A4AF4"
          />
        </g>
        <defs>
          <clipPath id="clip0_5164_4407">
            <rect
              width="34"
              height="13"
              fill="white"
              transform="translate(7 4)"
            />
          </clipPath>
        </defs>
      </>
    ),
  });

  return (
    <Icon
      w="element.xl"
      h="element.xl"
      viewBox="0 0 48 24"
      {...validateKeys(props)}
    />
  );
};
